import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useResource, useStore, useToast, usePage } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SF_REGN_CD_SRCH,
    SG_REGN_CD_LIST,
} from "@/tz/go/egaz/osci/ptl/cd/regncd/services/OsciRegnCdService";

/*
 * Region Code Management List
 * !== 지역 코드 관리 목록 ==!
 */
export const OSCI0109012Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "OSC0091" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });

    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();

    const form = {
        regnCdSrch: useForm({
            defaultSchema: SF_REGN_CD_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const grid = {
        regnCdList: useGrid({
            defaultSchema: SG_REGN_CD_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Retrieve a list of region codes. !== 지역코드 목록을 조회한다.==!
        getRegnCdList: useFetch({
            api: (page = grid.regnCdList.page) =>
                APIS.getRegnCdList(form.regnCdSrch.getValues(), page, grid.regnCdList.size),
            // 전체 조회가 오래 걸려 메뉴 최초 진입 시에는 자동 조회하지 않는다.
            // 검색을 한 번 수행했거나(isSubmitted) 상세에서 목록으로 돌아온 경우(pgeStore)에는
            // 이전 조회 조건 그대로 다시 조회한다.
            enabled: comnUtils.isEmpty(form.regnCdSrch.errors) && (form.regnCdSrch.isSubmitted || !!pgeStore),
            key: [grid.regnCdList.page, grid.regnCdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.regnCdSrch.getValues(),
                    page: grid.regnCdList.page,
                    size: grid.regnCdList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            regnCd: (props: any) => {
                const { rowValues, value } = props;
                return (
                    <Link to={`${URLS.osci0109014s}/${rowValues.regnCd}-${rowValues.cntyCd}-${rowValues.regnTpCd}`}>
                        {value}
                    </Link>
                );
            },
        },
    };

    const handler = {
        // handleSubmit 을 거쳐야 isSubmitted 가 true 가 되어 이후 페이징도 정상 동작한다
        getRegnCdList: () => {
            form.regnCdSrch.handleSubmit(
                () => {
                    grid.regnCdList.setPage(0);
                    fetch.getRegnCdList.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        // 전체 조회 시 응답이 오래 걸려 진입 시 자동 조회하지 않는다. 검색 버튼으로 조회한다.
        // handler.getRegnCdList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.regnCdSrch.schema.cntyCd} />
                            <Group.Control {...form.regnCdSrch.schema.regnTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdSrch.schema.regnCd} />
                            <Group.Control {...form.regnCdSrch.schema.regnNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button
                                role={"reset"}
                                onClick={() => {
                                    form.regnCdSrch.reset();
                                    form.regnCdSrch.setValues({
                                        cntyCd: "",
                                        regnTpCd: "",
                                        regnCd: "",
                                        regnNm: "",
                                    });
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getRegnCdList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.regnCdList.grid} data={fetch.getRegnCdList.data?.regnCdList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role={"new"}
                    onClick={() => {
                        navigate(`${URLS.osci0109013s}?menuId=${menuId}`);
                    }}
                />
            </Layout.Left>
        </Page>
    );
};
